module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/hero_mob-b46397f77435ff90d4f3cbbefac04a0a.jpg";